import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { SiteProvider } from "@/context/SiteContext";
import { AuthProvider } from "@/context/AuthContext";
import { SiteLayout } from "@/components/site/SiteLayout";
import Home from "@/pages/Home";
import Premium from "@/pages/Premium";
import ContentPage from "@/pages/ContentPage";
import Contact from "@/pages/Contact";
import AccountDeletion from "@/pages/AccountDeletion";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminDashboard from "@/pages/admin/AdminDashboard";

function ScrollTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

const Site = (el) => <SiteLayout>{el}</SiteLayout>;

function App() {
  return (
    <SiteProvider>
      <AuthProvider>
        <BrowserRouter>
          <ScrollTop />
          <Toaster position="top-center" richColors />
          <Routes>
            <Route path="/" element={Site(<Home />)} />
            <Route path="/premium" element={Site(<Premium />)} />
            <Route path="/privacy" element={Site(<ContentPage slug="privacy" badge="KVKK & Google Play Uyumlu" />)} />
            <Route path="/terms" element={Site(<ContentPage slug="terms" badge="Yasal" />)} />
            <Route path="/contact" element={Site(<Contact />)} />
            <Route path="/account-deletion" element={Site(<AccountDeletion />)} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminDashboard />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </SiteProvider>
  );
}

export default App;
